import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-1,0.5h0.5v1h-0.5zM0.5,0.5h1v1h-1z' },
    { paint: 'trunk', d: 'M-0.5,-0.5h1v2h-1z' },
    {
      paint: 'christmasGreen',
      d: 'M-0.5,-8h0.5v0.5h-0.5zM-1,-7.5h2v0.5h-2zM-1,-7h1.5v0.5h-1.5zM-1.5,-6.5h2v0.5h-2zM-1,-6h1.5v0.5h-1.5zM-1.5,-5.5h2v0.5h-2zM-2,-5h2.5v0.5h-2.5zM-2.5,-4.5h2.5v1h-2.5zM-2,-3.5h2v0.5h-2zM-2.5,-3h2.5v0.5h-2.5zM-3,-2.5h1.5v0.5h-1.5zM-1,-2.5h1.5v0.5h-1.5zM-3,-2h3v0.5h-3zM-3.5,-1.5h3.5v0.5h-3.5zM-3,-1h3v0.5h-3zM2.5,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'bushDark',
      d: 'M0.5,-7h0.5v0.5h-0.5zM0.5,-6.5h1v0.5h-1zM1,-6h0.5v0.5h-0.5zM0.5,-5.5h1v0.5h-1zM0.5,-5h1.5v0.5h-1.5zM0,-4.5h2v0.5h-2zM0,-4h2.5v0.5h-2.5zM0,-3.5h2v0.5h-2zM0,-3h2.5v0.5h-2.5zM0.5,-2.5h2v0.5h-2zM0,-2h0.5v0.5h-0.5zM1,-2h2v0.5h-2zM0,-1.5h3v0.5h-3zM0,-1h2.5v0.5h-2.5z',
    },
    {
      paint: 'christmasGold',
      d: 'M-0.5,-9.5h1v0.5h-1zM-1,-9h2v0.5h-2zM-1,-8.5h1.5v0.5h-1.5zM-1,-8h0.5v0.5h-0.5zM0,-8h0.5v0.5h-0.5zM-1.5,-6h0.5v0.5h-0.5zM-2.5,-3.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'christmasRed',
      d: 'M0.5,-6h0.5v0.5h-0.5zM-1.5,-2.5h0.5v0.5h-0.5zM0.5,-2h0.5v0.5h-0.5z',
    },
  ],
  pixels: 146,
};
const variant1: PixelSprite = {
  layers: [
    { paint: 'trunk', d: 'M-0.5,-0.5h1v2h-1z' },
    {
      paint: 'christmasGreen',
      d: 'M-0.5,-8h0.5v0.5h-0.5zM-1,-7.5h1.5v0.5h-1.5zM-1.5,-7h2v1h-2zM-1,-6h1.5v0.5h-1.5zM-1.5,-5.5h2v0.5h-2zM-2,-5h2.5v0.5h-2.5zM-2,-4.5h2v0.5h-2zM-2.5,-4h2.5v0.5h-2.5zM-2,-3.5h2v0.5h-2zM2,-3.5h0.5v0.5h-0.5zM-2.5,-3h2.5v0.5h-2.5zM-2.5,-2.5h1v0.5h-1zM-1,-2.5h1.5v0.5h-1.5zM-3,-2h3v0.5h-3zM-3.5,-1.5h3.5v0.5h-3.5zM3,-1.5h0.5v0.5h-0.5zM-3,-1h3v0.5h-3zM2.5,-1h0.5v0.5h-0.5zM0.5,-0.5h1v0.5h-1z',
    },
    {
      paint: 'bushDark',
      d: 'M0.5,-7h0.5v0.5h-0.5zM0.5,-6.5h1v0.5h-1zM1,-6h0.5v0.5h-0.5zM0.5,-5.5h1v0.5h-1zM0.5,-5h1.5v0.5h-1.5zM0,-4.5h2v0.5h-2zM0,-4h2.5v0.5h-2.5zM0,-3.5h2v0.5h-2zM0,-3h2.5v0.5h-2.5zM0.5,-2.5h2v0.5h-2zM0,-2h0.5v0.5h-0.5zM1,-2h2v0.5h-2zM0,-1.5h3v0.5h-3zM0,-1h2.5v0.5h-2.5z',
    },
    {
      paint: 'christmasGold',
      d: 'M-0.5,-9.5h1v0.5h-1zM-1,-9h2v0.5h-2zM-1,-8.5h1.5v0.5h-1.5zM-1,-8h0.5v0.5h-0.5zM0,-8h0.5v0.5h-0.5zM-1.5,-6h0.5v0.5h-0.5zM-2.5,-3.5h0.5v0.5h-0.5zM-2,-0.5h0.5v0.5h-0.5zM-2.5,0h1.5v0.5h-1.5zM1,0h1.5v1h-1.5z',
    },
    {
      paint: 'christmasRed',
      d: 'M0.5,-6h0.5v0.5h-0.5zM-1.5,-2.5h0.5v0.5h-0.5zM0.5,-2h0.5v0.5h-0.5zM-3,0h0.5v1h-0.5zM-1,0h0.5v0.5h-0.5zM-2,0.5h1.5v0.5h-1.5zM-3,1h2.5v0.5h-2.5zM-2,1.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'icicleBlue',
      d: 'M0.5,0.5h0.5v1h-0.5zM2.5,0.5h0.5v0.5h-0.5zM1.5,1h1.5v0.5h-1.5zM0.5,1.5h2v0.5h-2z',
    },
    { paint: 'snowCap', d: 'M-2.5,0.5h0.5v0.5h-0.5zM1,1h0.5v0.5h-0.5z' },
  ],
  pixels: 176,
};
const variant2: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-1,0.5h0.5v1h-0.5zM0.5,0.5h1v1h-1z' },
    { paint: 'trunk', d: 'M0,-8h0.5v0.5h-0.5zM1.5,-3h0.5v0.5h-0.5zM-0.5,-0.5h1v2h-1z' },
    {
      paint: 'christmasGreen',
      d: 'M-0.5,-8h0.5v0.5h-0.5zM-0.5,-7.5h1.5v0.5h-1.5zM-1,-7h1.5v0.5h-1.5zM1,-7h0.5v0.5h-0.5zM-1.5,-6.5h2v0.5h-2zM-1,-6h1.5v0.5h-1.5zM-1.5,-5.5h2v0.5h-2zM-2,-5h2.5v0.5h-2.5zM1.5,-5h0.5v0.5h-0.5zM-2,-4.5h2v1h-2zM2,-4.5h0.5v0.5h-0.5zM-1.5,-3.5h1.5v0.5h-1.5zM2,-3.5h0.5v1h-0.5zM-2.5,-3h2v0.5h-2zM-2.5,-2.5h1v0.5h-1zM-1,-2.5h1.5v0.5h-1.5zM2.5,-2.5h0.5v0.5h-0.5zM-3,-2h3v1h-3zM3,-1.5h0.5v0.5h-0.5zM-2.5,-1h2.5v0.5h-2.5zM2.5,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'bushDark',
      d: 'M0.5,-7h0.5v0.5h-0.5zM0.5,-6.5h1v0.5h-1zM1,-6h0.5v0.5h-0.5zM0.5,-5.5h1v1h-1zM0,-4.5h2v0.5h-2zM0,-4h2.5v0.5h-2.5zM0,-3.5h2v0.5h-2zM0,-3h1.5v0.5h-1.5zM0.5,-2.5h2v0.5h-2zM0,-2h0.5v0.5h-0.5zM1,-2h2v0.5h-2zM0,-1.5h3v0.5h-3zM0,-1h2.5v0.5h-2.5z',
    },
    {
      paint: 'christmasGold',
      d: 'M-0.5,-9.5h1v0.5h-1zM-1,-9h2v0.5h-2zM-1,-8.5h1.5v0.5h-1.5zM-1,-8h0.5v0.5h-0.5zM-1.5,-6h0.5v0.5h-0.5zM-2.5,-3.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'christmasRed',
      d: 'M0.5,-6h0.5v0.5h-0.5zM-1.5,-2.5h0.5v0.5h-0.5zM0.5,-2h0.5v0.5h-0.5z',
    },
    { paint: 'lanternGlow', d: 'M-2,-3.5h0.5v0.5h-0.5zM-0.5,-3h0.5v0.5h-0.5z' },
  ],
  pixels: 145,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
